
export class AccountEmailTemplateModel {
    public Id: number = 0;
    public EmailTemplateId: number = 0;
    public AccountId: number = 0;
    public Subject: string;
    public Body: string;
    public SMSBody: string;
    public LanguageId: number = 1;
}



// WEBPACK FOOTER //
// ./src/app/models/AccountEmailTemplateModel.ts